/// <reference types="@angular/localize" />

import { initAppConfig } from './app/core/app-config';
import { initAngular } from './app/core/angular';

(async () => {
  await initAppConfig();
  initAngular();
})();
